import * as tslib_1 from "tslib";
import React from 'react';
import ErrorBoundary from '../ErrorBoundary';
import { getDeviationResourceType } from '../DeviationViews/_helpers';
import { BiEventType } from '../biLogger/constants';
import SimpleBiButton from '../biLogger/Components/SimpleBiButton';
var FaveButton = /** @class */ (function (_super) {
    tslib_1.__extends(FaveButton, _super);
    function FaveButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onFaveToggle = function () {
            var _a = _this.props, deviation = _a.deviation, onChangeFave = _a.onChangeFave, isFavourite = _a.isFavourite;
            onChangeFave && onChangeFave(deviation, !isFavourite);
        };
        return _this;
    }
    FaveButton.prototype.render = function () {
        var _a = this.props, deviation = _a.deviation, isFavourite = _a.isFavourite, faveCount = _a.faveCount, isLoading = _a.isLoading, className = _a.className;
        return (React.createElement(ErrorBoundary, null,
            React.createElement(SimpleBiButton, { disabled: isLoading, onClick: this.onFaveToggle, className: className, biData: {
                    evid: BiEventType.THUMB_FAVE,
                    typeid: getDeviationResourceType(deviation),
                    creatorid: deviation.author
                        ? deviation.author.useridUuid
                        : undefined,
                    itemid: deviation.deviationId,
                } }, this.props.children({ isFavourite: isFavourite, faveCount: faveCount }))));
    };
    return FaveButton;
}(React.Component));
export default FaveButton;
//# sourceMappingURL=FaveButton.js.map